import { useState, useLayoutEffect } from 'react';
import { AxiosError } from 'axios';
import contentService from '../services/content-service/content-service';
import { GraphQLError } from '../models/persist-graphql-response/persist-graphql-response';

const useGraphqlPersistQueryContent = <T,>(
    persistedQueryName: string,
    persistedQueryParams?: Record<string, string>
) => {
    const [data, setData] = useState<T | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const fetchData = async () => {
        try {
            const response = await contentService.getGraphqlPersistQueryContent<
                T
            >(persistedQueryName, persistedQueryParams);
            if (response.data.errors) {
                const errorMessages = response.data.errors
                    .map((err: GraphQLError) => err.message)
                    .join(', ');
                throw new Error(errorMessages);
            }
            setData(response.data.data);
        } catch (err) {
            const axiosError = err as AxiosError;
            setError(axiosError.message || 'An unknown error occurred');
        } finally {
            setLoading(false);
        }
    };

    useLayoutEffect(() => {
        fetchData();
    }, [persistedQueryName, JSON.stringify(persistedQueryParams)]);

    return { data, loading, error };
};

export default useGraphqlPersistQueryContent;
